import { addToast } from 'src/toasts'

function initGoogleMap(locations) {
  const mapElement = document.getElementById("googleMap");
  if (!mapElement) {
    return; // Prevent errors if the map element does not exist
  }

  let geocoder = new google.maps.Geocoder()
  googleMap = new google.maps.Map(document.getElementById("googleMap"), {
    mapId: "GOOGLE_MAP",
    zoom: 12/*,
    center: {
      lat: coords.getAttribute("data-latitude"),
      lng: coords.getAttribute("data-longitude")
    }*/
  });

  let error = false

  for (let i = 0; i < Math.min(locations.length, 100); i++) {
    if (!error) {
      const loc = locations[i]

      geocoder.geocode({ address: loc.address }, (results, status) => {
        if (status === "OK") {
          const bgColor = (loc.color || '#EA4335')
          const borderColor = darken(bgColor, 0.22);
          const glyphColor  = glyphColorFor(bgColor);

          const pin = new google.maps.marker.PinElement({
            background: bgColor,
            borderColor: borderColor,
            glyphColor: borderColor
          });

          const marker = new google.maps.marker.AdvancedMarkerElement({
            map: googleMap,
            position: results[0].geometry.location,
            title: loc.title,
            content: pin.element
          });
          googleMap.setCenter(results[0].geometry.location);
        } else {
          addToast(I18n.t("errors.fetch_address"), 'error')
          error = true
        }
      });
    } else {
      break;
    }
  }

  $("#mainModal .loader").addClass('d-none')
  $("#mainModal #googleMap").removeClass('d-none')
}

function darken(hex, amount = 0.2) {
  const num = parseInt(hex.slice(1), 16);
  let r = (num >> 16) & 255;
  let g = (num >> 8) & 255;
  let b = num & 255;

  r = Math.round(r * (1 - amount));
  g = Math.round(g * (1 - amount));
  b = Math.round(b * (1 - amount));

  return `#${(r << 16 | g << 8 | b).toString(16).padStart(6, '0')}`;
}

function glyphColorFor(background) {
  const num = parseInt(background.slice(1), 16);
  const r = (num >> 16) & 255;
  const g = (num >> 8) & 255;
  const b = num & 255;

  // Perceived luminance
  const luminance = 0.299*r + 0.587*g + 0.114*b;

  return luminance > 140 ? "#000000" : "#FFFFFF";
}

// 🚨 **TODO.md F-129. Loaded ON DEMAND. This `$.getScript` used to sit at MODULE level**, so merely
// importing this file fetched the Maps API — and `packs/application.js` statically imports
// `packs/clients/functions`, which imports this, so **every desktop page for every role** pulled it.
// ⚠️ The `isRole('ADMIN')` check gates the *call* to `clientFunctions()`, not the `import`, which is
// evaluated regardless. Measured from the owner's Network tab on a hard reload of `/customers` with nothing
// map-related clicked: `9.js` 476 kB, `10.js` 468 kB, `places.js` 97.7, `main.js` 86.4, `util.js` 72.7,
// `common.js` 38.3, `controls.js` 26.8, `marker.js` 21.4 — **≈1.26 MB**. Cached on repeat visits, but the
// request to Google happened on every page view, with the key and the referrer, on pages with no map.
//
// 🚨 **`&loading=async` means the script's LOAD EVENT does not mean the API is ready, and resolving from
// `$.getScript` was a live bug on dev for a day (`TODO-ARCHIVE.md` F-145).** The comment here already said
// so and the code did it anyway: `.then()` on `$.getScript` called `google.maps.importLibrary` the moment
// the script element fired `load`, and with `loading=async` the bootstrap has not defined that function
// yet. The console said `google.maps.importLibrary is not a function`, from this line.
//
// 🔑 **The tell was that it failed only on the FIRST open per fresh page load.** A hard reload fetches the
// script anew, so the race is live; navigating away and back finds `window.google` already complete,
// because Turbolinks never resets the window. The memo reset below is what let the second click succeed,
// which is also what made this look intermittent rather than deterministic.
//
// ✅ **`callback=` is Google's readiness signal and the only correct one here.** It is invoked once the API
// is fully loaded, so `importLibrary` is guaranteed to exist by then. The promise therefore resolves from
// the callback, never from the script's load event.
// ⚠️ **Do not "simplify" this back to `$.getScript(...).then(...)`** — that is precisely the defect, and it
// reproduces only on a cold load, so it survives casual testing.
//
// 📌 The three libraries are the ones this file uses — `Geocoder` (geocoding), `Map` (maps),
// `AdvancedMarkerElement`/`PinElement` (marker). ⚠️ `places` was requested in the URL and **is used
// nowhere** in `app/javascript` or any view: ~100 kB of the figure above, dropped.
// 📌 **The memo is cleared on failure**, so a transient network error does not disable the map for the rest
// of the page's life — a rejected promise would otherwise be cached for ever.
let mapsApi = null

// Google calls this by name from the `callback=` parameter, so it has to be reachable as a global. One
// name, assigned once, rather than a per-call name that would leak on every open.
const MAPS_READY_CALLBACK = '__ihpGoogleMapsReady'

// A backstop, not a delay: if the script loads but the callback never arrives, the modal would sit on
// "Loading..." for ever, which is the fault `/code-review` raised. ⚠️ This is NOT the old
// `setTimeout(…, 300)` that guessed at readiness — nothing waits on this timer in the normal path; it only
// converts a hang into the error message.
const MAPS_READY_TIMEOUT_MS = 20000

function loadMapsApi() {
  mapsApi ||= new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error('Google Maps API did not signal ready')), MAPS_READY_TIMEOUT_MS)

    window[MAPS_READY_CALLBACK] = () => {
      clearTimeout(timer)
      resolve()
    }

    $.getScript('https://maps.googleapis.com/maps/api/js?key=' + process.env.GOOGLE_MAPS_API_KEY +
                '&loading=async&libraries=marker&callback=' + MAPS_READY_CALLBACK)
      .fail(() => {
        clearTimeout(timer)
        reject(new Error('Google Maps script failed to load'))
      })
  })
    .then(() => Promise.all([
      google.maps.importLibrary('maps'),
      google.maps.importLibrary('marker'),
      google.maps.importLibrary('geocoding')
    ]))
    .catch(error => {
      mapsApi = null
      throw error
    })

  return mapsApi
}

export function showGoogleMap(mainModal, title, locations) {
  let titleCode = ''
  if (title.length) {
    titleCode = '<div class="modal-header text-center"><h4 class="modal-title w-100 font-weight-bold">' + title + '</h4></div>'
  }

  $("#mainModal").html('<div class="modal-dialog"><div class="modal-content">' + titleCode + '<div class="modal-body text-center"><div id="googleMap" class="d-none"></div><div class="loader">Loading...</div></div><div class="modal-footer"><button id="modal-cancel" type="button" class="btn btn-secondary"><i class="bi bi-close"></i> ' + I18n.t("buttons.close") + '</button></div></div></div>')
  mainModal.show()

  // ⚠️ **Awaited, not timed.** `initGoogleMap` returns early when `#googleMap` is absent, so a user who
  // closes the modal before the API arrives is handled; a failure now says so instead of leaving the
  // "Loading..." text in place for ever, which is what the bare `setTimeout` did.
  loadMapsApi()
    .then(() => initGoogleMap(locations))
    .catch(() => {
      // 🔑 **Replace the "Loading..." text, and do NOT toast here.** `/code-review` caught the modal
      // loading for ever; `/simplify` then caught the fix double-toasting.
      // 🚨 `$.getScript` is a jQuery ajax call, and `packs/application.js`'s global `$(document).ajaxError`
      // already shows `errors.no_network` / `errors.unexpected_error` on `status === 0` — the identical
      // string, from the one place `CLAUDE.md` → *Error Handling* says network failures are reported. A
      // toast here made a blocked Maps fetch show the same message twice (`addToast` does not dedupe).
      // 📌 The message goes in the MODAL instead, which also covers the case the global handler cannot see:
      // an `importLibrary()` rejection after the script itself loaded is not an ajax failure.
      $('#mainModal .loader').replaceWith(
        $('<div class="text-danger"></div>').text(I18n.t('errors.unexpected_error'))
      )
    })
}
